import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
`;

export const LeftContainer = styled.div`
  height: 100%;
  max-width: 60%;

  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */

  .logo-icon {
    margin-top: max(40px, 25vh);
  }

  ${({ theme }) => css`
    padding: ${theme.padding.biggest} 0;
    background-color: ${theme.colors.darkGrey.main};

    .sub-logo-icon {
      margin-top: auto;
      justify-self: flex-end;
      margin-bottom: ${theme.padding.smallest};
    }
  `}
`;

export const RightContainer = styled.div`
  flex: 1;
  height: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: center;

  ${({ theme }) => css`
    padding: 0 calc(${theme.padding.biggest} * 2);
  `}
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 560px;
  margin-top: max(40px, 20vh);
  display: flex;
  flex-direction: column;
`;
